"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDashboardWidget = void 0;
const command_manager_1 = require("../../command_manager");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
const dashboard_1 = require("../../model/dashboard");
exports.deleteDashboardWidget = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { dashboardId, widgetId } = options;
        const snapshot = store_1.Selectors.getDashboardSnapshot(state);
        if (!snapshot) {
            return null;
        }
        const installedIds = store_1.Selectors.getInstalledWidgetInDashboard(state);
        if (!installedIds) {
            return null;
        }
        if (!installedIds.includes(widgetId)) {
            return null;
        }
        const deleteDashboardWidgetAction = dashboard_1.DashboardAction.deleteWidget2Action(snapshot, widgetId);
        if (!deleteDashboardWidgetAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: dashboardId,
            resourceType: types_1.ResourceType.Dashboard,
            actions: deleteDashboardWidgetAction,
        };
    },
};
//# sourceMappingURL=delete_dashboard_widget.js.map